/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { supabase } from '../../../services/supabase';
import { CheckInData } from '../types/queryTypes';

export async function getExistingCheckIn(
  userId: string | undefined,
  shadowId: string | undefined | null,
  dailySequence: number,
): Promise<Record<string, string[]>> {
  const { data, error } = await supabase.rpc('get_existing_check_in', {
    p_user_id: userId || null,
    p_shadow_id: shadowId || null,
    p_daily_sequence: dailySequence,
  });
  if (error) throw new Error(error.message);
  // Transform the array into a map of user_id to array of ids
  const checkInMap = (data || []) as { user_id: string; check_in_id: string }[];
  const existingCheckIn = checkInMap.reduce((acc, { user_id, check_in_id }) => {
    if (!acc[user_id]) acc[user_id] = [];
    acc[user_id].push(check_in_id);
    return acc;
  }, {} as Record<string, string[]>);
  return existingCheckIn;
}

export async function createNewCheckIn(
  userId: string,
  dailySequence: number,
  workLocation?: string | undefined,
): Promise<string> {
  const { data, error } = await supabase.rpc('create_new_check_in', {
    p_user_id: userId,
    p_daily_sequence: dailySequence,
    p_work_location: workLocation || null,
  });
  if (error) throw new Error(error.message);
  return data as string;
}

export async function submitCheckIn(data: CheckInData): Promise<string> {
  try {
    const { data: result, error } = await supabase.rpc('submit_check_in', {
      p_data: data,
    });
    if (error?.code === '23505') {
      throw new Error('23505');
    }
    if (error) {
      throw new Error(error.message);
    }
    return (result as string) || '';
  } catch (error) {
    if (error instanceof Error && error.message.includes('23505')) {
      throw error;
    }
    throw new Error(`Failed to submit check-in`);
  }
}

export async function deleteTicketCheckIn(
  id: string,
  checkInId: string,
  isLast = false,
): Promise<void> {
  const { error } = await supabase.rpc('delete_ticket_check_in', {
    p_id: id,
    p_check_in_id: checkInId,
    p_is_last: isLast,
  });
  if (error) throw new Error(error.message);
}
